<template>
  <div class="pl-overlay" @click="onClick"></div>
</template>

<script>
export default {
  name: 'overlay',
  methods: {
    onClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>
